const data = [
  {
    id: "requests",
    icon: "iconsminds-check",
    label: "menu.requests",
    to: "/app/staff/requests"
  },
  {
    id: "easee",
    icon: "iconsminds-notepad",
    label: "menu.easee",
    to: "/app/staff/easee"
  },
  {
    id: "bookings",
    icon: "iconsminds-id-card",
    label: "menu.bookings",
    to: "/app/staff/bookings"
  },
  {
    id: "fastCheckin",
    icon: "simple-icon-paper-plane",
    label: "menu.fastCheckin",
    to: "/app/staff/fastCheckin"
  },
  {
    id: "lolRequests",
    icon: "simple-icon-diamond",
    label: "menu.lolRequests",
    to: "/app/staff/lolRequests"
  },
  {
    id: "alacarte",
    icon: "iconsminds-chef-hat",
    label: "menu.alacarte",
    to: "/app/staff/alacarte",
    subs: [
      {
        icon: "iconsminds-check",
        label: "menu.requests",
        to: "/app/staff/alacarte/requests"
      },
      {
        icon: "simple-icon-note",
        label: "menu.restaurant",
        to: "/app/staff/alacarte/restaurants"
      }
    ]
  },
  {
    id: "settings",
    icon: "iconsminds-pen",
    label: "menu.settings",
    to: "/app/staff/settings",
    subs: [
      {
        icon: "simple-icon-note",
        label: "menu.template",
        to: "/app/staff/settings/template"
      },
      {
        icon: "simple-icon-bell",
        label: "menu.ringTone",
        to: "/app/staff/settings/ringTone"
      },
      {
        icon: "simple-icon-exclamation",
        label: "menu.reportProblem",
        to: "/app/staff/settings/reportProblem"
      }
    ]
  },
  {
    id: "webeeadmin",
    icon: "iconsminds-notepad",
    label: "menu.webeeadmin",
    to: "/app/staff/webeeadmin"
  }
  // {
  //   id: 'qr',
  //   icon: 'iconsminds-qr-code',
  //   label: 'menu.qr',
  //   to: '/app/staff/bookings'
  // },
  // ,
  // {
  //   id: 'blankpage',
  //   icon: 'iconsminds-bucket',
  //   label: 'menu.blank-page',
  //   to: '/app/blank-page'
  // },
  // {
  //   id: 'docs',
  //   icon: 'iconsminds-library',
  //   label: 'menu.docs',
  //   to: 'https://gogo-react-docs.coloredstrategies.com/',
  //   newWindow: true
  // }
];
export default data;
